export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    nuxtApp.hook("app:mounted", () => {
      const languagesToTrack = ["fr_CA", "fr-CA"];
      if (navigator && navigator.language && languagesToTrack.includes(navigator.language)) {
        window.ckySettings = {
          documentLang: "fr",
        };
      }
    });
  }
});
